import script from "./RelatedArtists.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatedArtists.vue?vue&type=script&setup=true&lang=js"

import "./RelatedArtists.vue?vue&type=style&index=0&id=05107e20&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05107e20"]])

export default __exports__